import config from './config';

// -----* Categories *-----
export const AddEditCategories = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/AddEditCategories`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add/edit category");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding/editing category:", error);
    throw error;
  }
};



// export const fetchCategories = async () => {
//   try {
//     const response = await fetch(`${config.baseUrl}/api/Entities/GetDashBoardCategories`);
//     if (!response.ok) {
//       throw new Error(`Network Error: ${response.statusText}`);
//     }
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching categories:", error);
//     throw error;
//   }
// };

export const FetchAllCategories = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Categories`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const AddNewCategories = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/AddCategories`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const UpdateCategories = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/UpdateCategories`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const FetchNestedCategories = async () =>{
  try {
    const response = await fetch(`${config.baseUrl}/api/Categories`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const result = await response.json();
    console.log('Raw categories API response:', result);
    console.log('Processed categories data:', result?.data?.data);
    
    // Log the structure of the first category with subcategories
    const categories = result?.data?.data;
    if (categories && categories.length > 0) {
      const categoryWithSubs = categories.find(cat => cat.subCategories && cat.subCategories.length > 0);
      if (categoryWithSubs) {
        console.log('Sample category structure:', categoryWithSubs);
        console.log('Sample subcategory structure:', categoryWithSubs.subCategories[0]);
        console.log('Subcategory properties:', Object.keys(categoryWithSubs.subCategories[0]));
      }
    }
    
    return result?.data?.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
}

export const GetCategoriesById = async (categoryId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/GetCategoriesById?CategoryId=${categoryId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch categories");
    }

    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const DeleteCategoriesById = async (categoryId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/DeleteCategoriesById?CategoryId=${categoryId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch categories");
    }

    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

// -----* Addresses *-----
export const fetchAddressesByUserID = async (userID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Address/user/${userID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch addresses");
    }

    const result = await response.json();
    
    // Handle the new API response structure
    if (result.success && result.data) {
      return result.data || [];
    } else {
      console.error("API returned unsuccessful response:", result.errors || result.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching addresses:", error);
    return [];
  }
};

export const AddNewAddress = async (data) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Address/AddAddress`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Failed to add new address: ${response.status}`);
    }

    const addedData = await response.json();
    return addedData;
  } catch (error) {
    console.error("Error adding new address:", error);
    throw error;
  }
};

export const updateAddress = async (data) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Address/EditAddress`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Failed to update address: ${response.status}`);
    }

    const updatedAddress = await response.json();
    return updatedAddress;
  } catch (error) {
    throw error;
  }
};

// -----* Orders *-----
export const ConfirmPayment = async (paymentData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Payment/stkPush`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paymentData),
    });

    if (!response.ok) {
      throw new Error(`Failed to confirm payment: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error confirming payment:", error);
    throw error;
  }
};

export const QueryPaymentStatus = async (checkoutRequestID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Payment/query-status`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        checkoutRequestID: checkoutRequestID
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to query payment status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error querying payment status:", error);
    throw error;
  }
};

export const Order = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/create`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    
    // Handle both success and error responses from new API format
    if (!response.ok) {
      // If HTTP status is not ok, but we got JSON response, return it
      // This allows us to handle structured error responses
      return data || {
        success: false,
        message: `Failed to place order: ${response.status}`,
        data: null
      };
    }

    return data;
  } catch (error) {
    console.error("Error placing order:", error);
    // Return structured error response
    return {
      success: false,
      message: "Network error occurred while placing order",
      data: null
    };
  }
};

export const UpdateOrderStatus = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/UpdateOrderStatus`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to place order: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error placing order:", error);
    throw error;
  }
};

export const GetOrders = async (userId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/user/${userId}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

export const GetOrderStatus = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/GetOrderStatus`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};



export const GetMerchantOrders = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/GetMerchantOrders`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to place order: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error placing order:", error);
    throw error;
  }
};

export const GetAdminOrders = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/GetAdminOrders`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to place order: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error placing order:", error);
    throw error;
  }
};

export const GetOrderDetails = async (orderId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/GetOrdersById?OrderId=${orderId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch addresses");
    }

    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching addresses:", error);
    return [];
  }
};

export const GetOrderTracking = async (orderId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/orders/tracking/${orderId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch tracking data: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching tracking data:", error);
    throw error;
  }
};

export const GetOrderTrackingByProductAndOrder = async (orderID, productID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Order/GetOrderTracking`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productID: productID,
        orderID: orderID
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch tracking data: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data[0] : data; // Get first tracking record
  } catch (error) {
    console.error("Error fetching order tracking data:", error);
    throw error;
  }
};

// -----* Reports *-----
export const GenerateReports = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Report/Generate`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to generate reports");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error generating reports:", error);
    throw error;
  }
};

export const ExportReports = async (format) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Report/Export`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(format),
    });

    if (!response.ok) {
      throw new Error("Failed to export reports");
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error exporting reports:", error);
    throw error;
  }
};

// -----* Authentication *-----
export const UserLogin = async (credentials) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/v2/Identity/login`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to login");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

 export const verifyToken = async (token) => {
    try {
      const response = await fetch(`${config.baseUrl}/WeatherForecast`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.ok;
    } catch (err) {
      console.error("Error verifying token:", err);
      return false;
    }
  };

export const SendEmailValidationCode = async (credentials) => {
  try {
    
    const response = await fetch(`${config.baseUrl}/api/v2/Identity/send-email-verification`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to send email verification");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending email verification:", error);
    throw error;
  }
};


export const SendResetCode = async (credentials) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Authentication/SendResetCode`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to login");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const VerifyEmailValidationCode = async (credentials) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/v2/Identity/verify-email`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to verify email");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error verifying email:", error);
    throw error;
  }
};

export const VerifyResetCode = async (credentials) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Authentication/VerifyResetCode`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to login");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const ResetPassword = async (credentials) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Authentication/ResetPassword`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error("Failed to login");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const UserRegister = async (userData) => {
  try {
    // Prepare request data according to new v2 Identity API structure
    const requestData = {
      userName: userData.userName,
      email: userData.email,
      phoneNumber: userData.phoneNumber,
      password: userData.password,
      reEnteredpassword: userData.confirmPassword,
      role: "User" // Default role
    };

    const response = await fetch(`${config.baseUrl}/api/v2/Identity/register`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error("Failed to register");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error registering:", error);
    throw error;
  }
};

// -----* Products *-----
export const AddProduct = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/AddProducts`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
};

export const EditProduct = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/EditProducts`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
};

export const LoadProductImages = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/LoadProductImages`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
};

export const GetProductsByCategory = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/GetProductsByCategory`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
};

export const FetchProducts = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/GetAllProducts`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    // Check if the response is OK (status code 200-299)
    if (!response.ok) {
      throw new Error(`Failed to Get Products ${response.status}`);
    }

    // Parse the JSON data
    const data = await response.json();

    // Return the data
    return data;
  } catch (error) {
    console.error("Error in FetchProducts:", error); // Log the error for debugging
    throw error; // Re-throw the error for the caller to handle
  }
};

// Fetch single product by ID for better performance
export const FetchProductById = async (productId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/GetProduct/${productId}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    // Check if the response is OK (status code 200-299)
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Product not found');
      }
      throw new Error(`Failed to Get Product ${response.status}`);
    }

    // Parse the JSON data
    const responseData = await response.json();

    // Check if the response has the expected structure and extract the product data
    if (responseData.success && responseData.data) {
      // Transform the API response to match the expected product structure
      const product = responseData.data;
      return {
        ...product,
        // Map fields to maintain compatibility with existing components
        imageUrl: JSON.stringify(product.imageUrls || []),
        inStock: product.stockQuantity > 0,
        keyFeatures: product.features || "",
        specification: product.productSpecification || "",
        box: JSON.stringify([product.boxContents] || []),
      };
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error("Error in FetchProductById:", error); // Log the error for debugging
    throw error; // Re-throw the error for the caller to handle
  }
};



// -----* Deliverables *-----
export const fetchCountryCodes = async () => {
  try {
    const response = await fetch("https://restcountries.com/v3.1/all");
    const data = await response.json();
    const codes = data
      .map((country) => ({
        name: country.name.common,
        code: country.idd.root + (country.idd.suffixes ? country.idd.suffixes[0] : ""),
      }))
      .filter((country) => country.code);
    return codes;
  } catch (error) {
    console.error("Error fetching country codes:", error);
  }
};

export const fetchCounties = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Deliveries/counties`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching counties:", error);
    return [];
  }
};

export const fetchCountyTowns = async (countyId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Deliveries/towns?countyId=${countyId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching towns:", error);
    return [];
  }
};

export const fetchDeliveryStations = async (townId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Deliveries/deliveryStations?townId=${townId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching towns:", error);
    return [];
  }
};

// -----* Carts *-----

export const AddCartItems = async (requestData) => {
  try {
    // Transform request data to match new API structure
    const apiRequestData = {
      applicationUserId: requestData.applicationUserId,
      productId: requestData.productId,
      quantity: requestData.quantity
    };

    const response = await fetch(`${config.baseUrl}/api/Cart/cart/add`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(apiRequestData),
    });
 
    if (!response.ok) {
      throw new Error("Failed to add item to cart");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding item to cart:", error);
    throw error;
  }
};

export const GetCartItems = async (applicationUserId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/cart?applicationUserId=${applicationUserId}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get cart items");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting cart items:", error);
    throw error;
  }
};

// New cart count function using the new API endpoint
export const GetCartCount = async (applicationUserId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/cart/count?applicationUserId=${applicationUserId}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get cart count");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting cart count:", error);
    throw error;
  }
};

// New cart total function
export const GetCartTotal = async (applicationUserId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/cart/total?applicationUserId=${applicationUserId}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get cart total");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting cart total:", error);
    throw error;
  }
};

// Move item from saved to cart
export const MoveSavedToCart = async (requestData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/saved/move-to-cart`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error("Failed to move item to cart");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error moving item to cart:", error);
    throw error;
  }
};

// Move item from cart to saved
export const MoveCartToSaved = async (requestData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/cart/move-to-saved`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error("Failed to move item to saved");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error moving item to saved:", error);
    throw error;
  }
};

// Delete saved item
export const DeleteSavedItem = async (productId, applicationUserId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/saved/${productId}?applicationUserId=${applicationUserId}`, {
      method: "DELETE",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete saved item");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting saved item:", error);
    throw error;
  }
};

// Data.js
export const GetPersonalizedRecommendations = async (userId, limit = 5) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/recommendations/personalized/${userId}&limit=${limit}`);
    if (!response.ok) {
      throw new Error("Failed to get personalized recommendations");
    }
    return await response.json();
  } catch (error) {
    console.error("Error getting personalized recommendations:", error);
    throw error;
  }
};

export const GetComplementaryProducts = async (productId, limit = 5) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/recommendations/complementary/${productId}`);
    if (!response.ok) {
      throw new Error("Failed to get complementary products");
    }
    return await response.json();
  } catch (error) {
    console.error("Error getting complementary products:", error);
    throw error;
  }
};

export const GetFrequentlyBought = async (productId, limit = 5) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/recommendations/frequently-bought/${productId}`);
    if (!response.ok) {
      throw new Error("Failed to get frequently bought products");
    }
    return await response.json();
  } catch (error) {
    console.error("Error getting frequently bought products:", error);
    throw error;
  }
};

export const GetSimilarProducts = async (productId, limit = 5) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/recommendations/similar/${productId}`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch similar products");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching similar products:", error);
    throw error;
  }
};

export const GetBoughtItems = async (userId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/bought-items?applicationUserId=${userId}`, {
      method: "Get",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to save items");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error saving items:", error);
    throw error;
  }
};

export const SaveItems = async (requestData) => {
  try {
    // Transform request data to match new API structure
    const apiRequestData = {
      applicationUserId: requestData.applicationUserId,
      productId: requestData.productId,
      quantity: requestData.quantity || 1
    };

    const response = await fetch(`${config.baseUrl}/api/Cart/saved`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(apiRequestData),
    });

    if (!response.ok) {
      throw new Error("Failed to save item");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error saving item:", error);
    throw error;
  }
};

export const GetSavedItems = async (applicationUserId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/saved?applicationUserId=${applicationUserId}`);

    if (!response.ok) {
      throw new Error("Failed to get saved items");
    }

    return await response.json();
  } catch (error) {
    console.error("Error getting saved items:", error);
    throw error;
  }
};

export const DeleteCartItems = async (requestData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Cart/DeleteCartItems`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error("Failed to delete cart items");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting cart items:", error);
    throw error;
  }
};


// -----* Role Modules *-----
export const fetchRoleModules = async (RoleID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/SystemSecurity/role-modules?RoleID=${RoleID}`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching role modules:", error);
    throw error;
  }
};

export const fetchSubModuleCategories = async (subModuleID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/SystemSecurity/submodule-categories?subModuleID=${subModuleID}`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching submodule categories:", error);
    throw error;
  }
};

// -----* Features *-----

export const FetchAllFeatures = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Features/GetAllFeatures`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching features:", error);
    throw error;
  }
};

export const FetchFeatures = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Features/GetFeatures`, {
      method: "POST",
      headers: { 
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching features:", error);
    throw error;
  }
};

export const AddFeaturesAPI = async (formData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Features/AddFeatures`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Failed to add features: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding features:", error);
    throw error;
  }
};

// -----* Personal Information *-----
export const FetchPersonalInformation = async (userId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Entities/user/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch personal information");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching personal information:", error);
    throw error;
  }
};

export const SavePersonalInformation = async (userID, data) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Entities/UpdatePersonalInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body: JSON.stringify({ userId: userID, ...data }),
    });

    if (!response.ok) {
      throw new Error(`Failed to save personal information: ${response.status}`);
    }

    const savedData = await response.json();
    return savedData;
  } catch (error) {
    console.error("Error saving personal information:", error);
    throw error;
  }
};

//------* Merchants * -------
export const AddMerchants = async (formData) =>{
  try{
     const response = await fetch(`${config.baseUrl}/api/SystemMerchant/AddMerchantsAsync`,{
      method : "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body : JSON.stringify(formData)
     });
     if(!response.ok){
      throw new Error(`Failed to add merchant ${response.status}`)
     }
     const data = response.json();

     return data;

  }catch(error){
    throw error;
  }
}

export const UpdateMerchants = async (formData) =>{
  try{
     const response = await fetch(`${config.baseUrl}/api/SystemMerchant/UpdateMerchantsAsync`,{
      method : "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body : JSON.stringify(formData)
     });
     if(!response.ok){
      throw new Error(`Failed to add merchant ${response.status}`)
     }
     const data = response.json();

     return data;

  }catch(error){
    throw error;
  }
}
export const FetchMerchants = async ()=>{
  try{
    var response = await fetch(
      `${config.baseUrl}/api/SystemMerchant/GetAllMerchants`,{
        method : "GET",
        headers :{
          Accept : "*/*",
          "Content-type" : "application/json"
        }
      });

      if(!response.ok){
        throw new Error(`Failed to Get Merchants ${response.status}`)
      }

      const merchants = response.json();
      return merchants;


  }catch(error){
    throw error;
  }

}

export const FetchMerchantsById = async (merchantId)=>{
  try{
    const response = await fetch(`${config.baseUrl}/api/SystemMerchant/GetMerchantById?merchantID=${merchantId}`,{
      method : "Get",
      headers :{
        Accept : "*/*",
        "Content-type" : "application/json"
      }
    });
    if(response.ok){
      throw new Error(`Failed to get Merchant By ID ${response.json}`)
    } 
  
    const merchantById = response.json();
  
    return merchantById;
  }catch(error){
    throw error;
  }
  
}

export const DeleteMerchants = async (formData) =>{
  try{
     const response = await fetch(`${config.baseUrl}/api/SystemMerchant/DeleteMerchantsAsync`,{
      method : "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
      },
      body : JSON.stringify(formData)
     });
     if(!response.ok){
      throw new Error(`Failed to add merchant ${response.status}`)
     }
     const data = response.json();

     return data;

  }catch(error){
    throw error;
  }
}

// ------** Search ** --------

export const FetchFilteredProducts = async (requestData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Search/GetFilteredProducts`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching filtered products:", error);
    throw error;
  }
};

export const FetchSearchProducts = async (subCategoryID) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Category/GetSearchProducts/${subCategoryID}`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching search products:", error);
    throw error;
  }
};

// Fetch products by subcategory - POST method
export const FetchProductsBySubCategory = async (subCategoryId) => {
  console.log('FetchProductsBySubCategory called with:', subCategoryId);
  console.log('Parameter type:', typeof subCategoryId);
    
  try {
    const response = await fetch(`${config.baseUrl}/api/Product/subcategory/${subCategoryId}`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log('Products API response:', data);
    return data.data || data; // Handle different response structures
  } catch (error) {
    console.error("Error fetching products by subcategory:", error);
    throw error;
  }
};

// -----* Advertisement APIs *-----

// Fetch advertisements by location and user preferences
export const FetchAdsByLocation = async (location = 'home', userId = null, userPreferences = {}) => {
  try {
    const queryParams = new URLSearchParams({
      location,
      ...(userId && { userId }),
      ...userPreferences
    });

    const response = await fetch(`${config.baseUrl}/api/Advertisement/GetAdsByLocation?${queryParams}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ads: ${response.status}`);
    }

    const data = await response.json();
    return data.data || data;
  } catch (error) {
    console.error("Error fetching ads by location:", error);
    throw error;
  }
};

// Fetch all active advertisements
export const FetchAllAds = async () => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/GetAllActiveAds`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ads: ${response.status}`);
    }

    const data = await response.json();
    return data.data || data;
  } catch (error) {
    console.error("Error fetching all ads:", error);
    throw error;
  }
};

// Track advertisement interaction (click, view, etc.)
export const TrackAdInteraction = async (interactionData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/TrackInteraction`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        adId: interactionData.ad?.id,
        userId: interactionData.userId,
        interactionType: interactionData.action, // 'click', 'view', 'close', etc.
        location: interactionData.location,
        timestamp: interactionData.timestamp,
        metadata: {
          adType: interactionData.adType,
          deviceInfo: navigator.userAgent,
          referrer: document.referrer
        }
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to track ad interaction: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error tracking ad interaction:", error);
    // Don't throw error for tracking failures
    return null;
  }
};

// Fetch personalized ads based on user behavior
export const FetchPersonalizedAds = async (userId, limit = 10) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/GetPersonalizedAds/${userId}?limit=${limit}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch personalized ads: ${response.status}`);
    }

    const data = await response.json();
    return data.data || data;
  } catch (error) {
    console.error("Error fetching personalized ads:", error);
    throw error;
  }
};

// Fetch featured products for advertisement
export const FetchFeaturedProducts = async (limit = 10, category = null) => {
  try {
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      ...(category && { category })
    });

    const response = await fetch(`${config.baseUrl}/api/Product/GetFeaturedProducts?${queryParams}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch featured products: ${response.status}`);
    }

    const data = await response.json();
    return data.data || data;
  } catch (error) {
    console.error("Error fetching featured products:", error);
    throw error;
  }
};

// Add new advertisement (Admin function)
export const AddAdvertisement = async (adData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/AddAdvertisement`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(adData),
    });

    if (!response.ok) {
      throw new Error(`Failed to add advertisement: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding advertisement:", error);
    throw error;
  }
};

// Update advertisement (Admin function)
export const UpdateAdvertisement = async (adId, adData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/UpdateAdvertisement/${adId}`, {
      method: "PUT",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(adData),
    });

    if (!response.ok) {
      throw new Error(`Failed to update advertisement: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating advertisement:", error);
    throw error;
  }
};

// Delete advertisement (Admin function)
export const DeleteAdvertisement = async (adId) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Advertisement/DeleteAdvertisement/${adId}`, {
      method: "DELETE",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete advertisement: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting advertisement:", error);
    throw error;
  }
};

export const GetSuggestions = async (query) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Search/SearchSuggestion?query=${query}`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching search products:", error);
    throw error;
  }
};


export const GetProductsSearch = async (query) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Search/SearchProducts?query=${query}`);
    if (!response.ok) {
      throw new Error(`Network Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching search products:", error);
    throw error;
  }
};

// ------** UPLOADS ** --------
export const FileUploads = async (fileData) => {
  try {
    const response = await fetch(`${config.baseUrl}/api/Entities/UploadImages`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        // Do NOT set Content-Type manually for FormData
      },
      body: fileData, // Send the FormData object directly
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file: ${response.status}`);
    }

    const uploadedFile = await response.json(); // Parse the JSON response
    return uploadedFile;
  } catch (error) {
    throw error;
  }
};